export const env = {
  appName: 'QA Tools',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  apiBaseUrl:
    import.meta.env.VITE_API_BASEURL || 'https://qa-tools-api.merapi.javan.id',

  keycloakUrl:
    import.meta.env.VITE_KEYCLOAK_URL || 'https://keycloak.merapi.javan.id',
  keycloakRealm: import.meta.env.VITE_KEYCLOAK_REALM || 'internal',
  keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'qa-tools',

  sentryDsn:
    import.meta.env.VITE_SENTRY_DSN ||
    'VITE_SENTRY_DSN=https://3dd668f1ac226a095090ee1981fed7a1@sentry.cloud.javan.co.id/168',
};
